import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIOS_ALTERAR_SENHA_BEGIN,
  USUARIOS_ALTERAR_SENHA_SUCCESS,
  USUARIOS_ALTERAR_SENHA_FAILURE,
  USUARIOS_ALTERAR_SENHA_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function alterarSenha(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIOS_ALTERAR_SENHA_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissAlterarSenhaError() {
  return {
    type: USUARIOS_ALTERAR_SENHA_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIOS_ALTERAR_SENHA_BEGIN actions
export function* doAlterarSenha(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioApi = new Services['UsuarioApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioApi.changePassword(action.data.senhaAtual, action.data.senhaNova);
  } catch (err) {
    yield put({
      type: USUARIOS_ALTERAR_SENHA_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIOS_ALTERAR_SENHA_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIOS_ALTERAR_SENHA_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIOS_ALTERAR_SENHA_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchAlterarSenha() {
  yield takeLatest(USUARIOS_ALTERAR_SENHA_BEGIN, doAlterarSenha);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_ALTERAR_SENHA_BEGIN:
      return {
        ...state,
        alterarSenhaPending: true,
        alterarSenhaError: null,
      };

    case USUARIOS_ALTERAR_SENHA_SUCCESS:
      return {
        ...state,
        alterarSenhaPending: false,
        alterarSenhaError: null,
      };

    case USUARIOS_ALTERAR_SENHA_FAILURE:
      return {
        ...state,
        alterarSenhaPending: false,
        alterarSenhaError: action.data.error,
      };

    case USUARIOS_ALTERAR_SENHA_DISMISS_ERROR:
      return {
        ...state,
        alterarSenhaError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuarios/redux/alterarSenha.js